// authUser.js
let cachedUser = null;

export const setCachedUser = (user) => {
  cachedUser = user;
};

export const getCachedUser = () => cachedUser;
